module.exports = __webpack_public_path__ + "static/media/banner.c0c4d073.svg";